module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.981d59e2.jpg";